var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',[_c('h2',[_vm._v("Something went wrong, please try again.")])]):_c('div',[_vm._t("default",null,null,_vm.payload)],2)}
var staticRenderFns = []

export { render, staticRenderFns }